import React from 'react';

import Hero from '../components/hero';
import Layout from '../components/layout';
import Seo from '../components/seo';

const NotFoundPage = () => (
  <Layout>
    <Hero
      heroImage="hero--subpage.png"
      heroHeading="Sivua ei löydy"
      heroDescription="Voi harmi, tästä osoitteesta ei löydy mitään. Jos epäilet virhettä sivustolla niin pyydämme ottamaan yhteyttä sähköpostitse asiakaspalvelu@urakkadiili.fi."
    />
  </Layout>
);

export default NotFoundPage;

export const Head = () => <Seo title="404: Sivua ei löydy" />;
